// go-chat-duplication
import { Directive, OnInit, inject, input } from '@angular/core';

import { GoPrimaryNotificationComponent } from './go-primary-notification/go-primary-notification.component';
import { GoDashboardNotification } from './go-dashboard-notification';
import { GoDatabaseNotificationType } from '@shared/services/go-notifications/go-database-notification-type';

@Directive({
  selector: '[appGoChatRequestNotification]',
})
export class GoChatRequestNotificationDirective implements OnInit {
  private primaryNotificationComponent = inject(GoPrimaryNotificationComponent, { host: true });

  readonly notificationData = input.required<GoDatabaseNotificationType>();

  ngOnInit() {
    const { fromTherapistFirstName, fromTherapistLastName } = this.notificationData().data;
    const therapistName = `${fromTherapistFirstName} ${fromTherapistLastName}`;

    let icon: string;
    const link = '/therapist/go-chat-requests';
    let title: string;
    let message: string;
    const timestamp = this.notificationData().ts;
    const readAtTime = this.notificationData().read;
    const id = this.notificationData().id;

    switch (this.notificationData().data.requestType) {
      case 'chat-patient-request': {
        icon = 'chat';
        title = 'New Chat Request';
        message = `You have received a new chat request from a patient.`;
        break;
      }
      case 'chat-therapist-handover': {
        icon = 'next_week';
        title = 'Patient Handover';
        message = `${therapistName} has requested to hand over a patient to you.`;
        break;
      }
      case 'chat-therapist-invite-and-leave':
      case 'chat-therapist-invite': {
        icon = 'person_add';
        title = 'New Chat Invite';
        message = `${therapistName} has invited you into a chat.`;
        break;
      }
    }

    this.primaryNotificationComponent.notification.set(
      new GoDashboardNotification(icon, link, title, message, timestamp, readAtTime, id)
    );
  }
}
